import { useTextTranslation } from "../../utils/useTextTranslation";
import React, { useEffect, useRef, useState } from "react";
import ToBeReacordIcon from "../../assets/icons/svg/ToBeReacordIcon";
import localizationStrings from "../../statics/localization";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import Notification from "../notification";
import { removeRecord } from "../../api/npvr/npvr";
import SinglePlayIcon from "../../assets/icons/svg/SinglePlayIcon";
import PlayerPlayIcon from "../../assets/icons/svg/PlayerPlayIcon";
import InfoIcon from "../../assets/icons/svg/InfoIcon";
import defaultHorizontalPoster from "../../assets/images/default-vod-horizontal-poster.png";
import { recordDateLabel, recordStateLabel, playableRecord } from "../../utils/recording";
import { flowCopy } from "../../utils/flowCopy";
import { prettyTimeFormatter } from "../../utils/prettyTimeFormatter";

const UserRecordItem = ({
  item,
  setDeletedRecordCode,
  clickRecord,
  isEpisode,
  selectedFilter,
  setPopupOpened
}) => {
  const translateText = useTextTranslation();
  const [posterUrl, setPosterUrl] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [isPlayHovered, setIsPlayHovered] = useState(false);
  const deleting = useRef(false);
  const [deleteError, setDeleteError] = useState(false);

  const deleteRecord = async () => {
    if (deleting.current) return;
    deleting.current = true;
    setDeleteError(false);
    try {
      const data = await removeRecord(item?.epgProgramId, false,
        item?.npvrRecordUId || item?.UId || item?.id,
        item?.channelUId || item?.ChannelUId || item?.channelId);
      if (data.status !== 200) throw new Error("Recording removal failed");
      setDeletedRecordCode(item?.epgProgramId);
      setShowNotification(false);
      setPopupOpened(false);
    } catch (error) {
      setDeleteError(true);
    } finally {
      deleting.current = false;
    }
  };

  useEffect(() => {
    if (item) {
      let poster = item?.posters?.find(
        (poster) => poster.posterType === "HorizontalLow"
      );

      setPosterUrl(poster?.posterUrl);
    }
  }, [item]);

  return (
    <div className="record-card">
      <div
        className="record-poster-wrapper"
        style={{
          backgroundColor: !posterUrl || posterUrl === defaultHorizontalPoster ? '#666666' : 'transparent',
          borderRadius: !posterUrl || posterUrl === defaultHorizontalPoster ? '8px' : '0px',
          position: 'relative'
        }}
      >
        {posterUrl && posterUrl !== defaultHorizontalPoster ? (
          <img
            src={posterUrl}
            onError={() => {
              setPosterUrl(defaultHorizontalPoster);
            }}
          />
        ) : (
          <div 
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#666666',
              borderRadius: '8px',
              margin: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
        )}
        
        {/* Hover play icon overlay */}
        {playableRecord(item) &&(
        <div 
          className="record-hover-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
            borderRadius: !posterUrl || posterUrl === defaultHorizontalPoster ? '8px' : '0px',
            pointerEvents: 'none'
          }}
        >
          <PlayerPlayIcon />
        </div>
        )}
        
        {playableRecord(item) && (isEpisode || item?.isseries !== "1") ? (
          <div className="record-gradient">
            <div
              className="record-play-button"
              onClick={(e) => {
                e.stopPropagation();
                clickRecord(item, "play");
              }}
            >
              <SinglePlayIcon />
            </div>
          </div>
        ) : null}
      </div>

      <div className="info-box">
        <div
          className="row"
          style={{ marginTop: "0.5vw", marginBottom: ".26vw" }}
        >
          <label
            className="title"
            style={{ fontSize: selectedFilter === 2 ? '1vw' : undefined }}
          >
            {translateText(item?.title)}{" "}
            {isEpisode && recordDateLabel(item?.startTime ?? item?.releaseDate)}
          </label>
        </div>
        <div className="row">
          {!item?.category ? (
            <div className="info" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label>{translateText(item?.genre)}</label>
              <div className="date">
                {item?.isSerie
                  ? localizationStrings.series
                  : prettyTimeFormatter(item?.duration)}
              </div>
              {/* staticly added will be recorded label for recording items */}
              {selectedFilter !== 1 && (
                <div style={{ color: "#F15A23", display: "flex", alignItems: "center", justifyContent: "center"}}>
                  <span style={{ color: "#F15A23" ,paddingTop: '0.16rem' }}>
                    <ToBeReacordIcon />
                  </span>
                  <label className="label" style={{ color: "#F15A23" }}>
                    {recordStateLabel(item)}
                  </label>
                </div>
              )}
            </div>
          ) : (
            <div className="info" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div className="date">
                {item?.isSerie
                  ? localizationStrings.series
                  : prettyTimeFormatter(item?.duration)}
              </div>
              {/* staticly added will be recorded label for recording items */}
              {selectedFilter !== 1 && (
                <div style={{ color: "#F15A23", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ color: "#F15A23",paddingTop: '0.16rem' }}>
                    <ToBeReacordIcon />
                  </span>
                  <label className="label" style={{ color: "#F15A23" }}>
                    {recordStateLabel(item)}
                  </label>
                </div>
              )}
            </div>
          )}
        </div>

        {/*    <div className="row">
          {item?.newstatus === "999" ? (
            <div className="status red">
              <span style={{ marginTop: ".208vw" }}>
                <ToBeReacordIcon />
              </span>
              <label className="label">{localizationStrings.recording}</label>
            </div>
          ) : item?.newstatus === "0" ? (
            <div className="status blue">
              <span style={{ marginTop: ".104vw" }}>
                <ToBeReacordIcon />
              </span>
              <label className="label">
                {recordStateLabel(item)}
              </label>
            </div>
          ) : null}
        </div> */}
      </div>

      <div className="action-buttons">
      {playableRecord(item) && (
        <div
          className="play-button"
          onClick={() => {
            clickRecord(item, "play");
          }}
          onMouseEnter={() => setIsPlayHovered(true)}
          onMouseLeave={() => setIsPlayHovered(false)}
        >
          <div
            style={{
              color: isPlayHovered ? "#F15A23" : "#FFFFFF",
              fontSize: "18px",
              lineHeight: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            title={localizationStrings.inspect}
          >
            <InfoIcon />
          </div>
        </div>
      )}
        <div
          className="delete-button"
          onClick={() => {
            setShowNotification(true);
            setPopupOpened(true);
          }}
        >
          <TrashIcon />
        </div>
      </div>

      {deleteError && <p role="alert">{flowCopy().loadError}</p>}
      {showNotification ? (
        <Notification
          text={localizationStrings.deleteRecordConfirmText}
          confirmText={localizationStrings.yes}
          notConfirmText={localizationStrings.no}
          onClickConfirm={deleteRecord}
          onClickNotConfirm={() => {
            setShowNotification(false);
            setPopupOpened(false);
          }}
          switchButtons={true}
        />
      ) : null}
    </div>
  );
};

export default UserRecordItem;
